"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const CardHeader_1 = __importDefault(require("@material-ui/core/CardHeader"));
const styles_1 = require("@material-ui/core/styles");
const Text_1 = __importDefault(require("../Text"));
const useStyles = styles_1.makeStyles((theme) => ({
    root: ({ withHover }) => (Object.assign({}, (withHover && {
        '&:hover': {
            backgroundColor: theme.palette.info.light,
        },
    }))),
}));
/**
 * A Card renders the basic information of a resource
 * */
const Card = ({ title = '', subtitle = '', titleTypographyProps, children, onClick, onMouseEnter, onMouseMove, onMouseOut, withHover, }) => {
    const styles = useStyles({ withHover });
    const content = (react_1.default.createElement(CardContent_1.default, null, typeof children === 'string' ? react_1.default.createElement(Text_1.default, { variant: "p" }, children) : children));
    return (react_1.default.createElement(Card_1.default, { className: styles.root, onClick: onClick, onMouseEnter: onMouseEnter, onMouseMove: onMouseMove, onMouseOut: onMouseOut },
        react_1.default.createElement(CardHeader_1.default, { title: title, subheader: subtitle, titleTypographyProps: titleTypographyProps }),
        content));
};
exports.default = Card;
//# sourceMappingURL=index.js.map